import { render, staticRenderFns } from "./ClientProfileEdition.vue?vue&type=template&id=21ad2bd4&"
import script from "./ClientProfileEdition.vue?vue&type=script&lang=js&"
export * from "./ClientProfileEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports